<div class="theme-switcher-container" [ngClass]="classList">
  <mat-icon *ngIf="showIcons" class="mr-2" [ngClass]="{ active: (isLightThemeActive$ | async) }">
    light_mode
  </mat-icon>
  <mat-slide-toggle class="flex align-items-center" [checked]="isDarkThemeActive$ | async" (change)="useDarkTheme($event)"></mat-slide-toggle>
  <mat-icon *ngIf="showIcons" class="ml-2" [ngClass]="{ active: (isDarkThemeActive$ | async) }">
    dark_mode
  </mat-icon>
</div>
